var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CRow',[_c('CCol',[_c('p',[_c('strong',[_vm._v(" LOG: ")]),_vm._v(" "+_vm._s(_vm.params.log)+" ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }